
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { SubjectTypeResponse } from "../../models/dtos";

export const subjectTypesApi = createApi({
  reducerPath: 'subjectTypesApi',
  baseQuery: baseAuthQuery('SubjectTypes'),
  tagTypes: ['SubjectType'],
  endpoints: (builder) => ({
    getSubjectTypes: builder.query<ApiResponse<SubjectTypeResponse[]>, void>({
      query: () => "",
      providesTags: ['SubjectType'],
    }),
    getSubjectTypeById: builder.query<ApiResponse<SubjectTypeResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['SubjectType'],
    }),
    updateSubjectType: builder.mutation<ApiResponse<SubjectTypeResponse>, Partial<SubjectTypeResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ['SubjectType'],
    }),
    deleteSubjectType: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ['SubjectType'],
    }),
  }),
});
